import { HapticFeedbackTypes, triggerHapticFeedback } from '@/utils/haptic-feedback';
import { logger } from '@/utils/logging';

const RIPS_HAPTIC_INTENTS = ['light', 'medium', 'heavy', 'success'] as const;

export type RipsHapticIntent = (typeof RIPS_HAPTIC_INTENTS)[number];

const HAPTICS: Record<RipsHapticIntent, HapticFeedbackTypes> = {
    light: HapticFeedbackTypes.impactLight,
    medium: HapticFeedbackTypes.impactMedium,
    heavy: HapticFeedbackTypes.impactHeavy,
    success: HapticFeedbackTypes.notificationSuccess,
};

export const triggerRipsHaptic = (intent?: RipsHapticIntent) => {
    if (!intent || !RIPS_HAPTIC_INTENTS.includes(intent)) {
        logger.debug('[triggerRipsHaptic]', 'Invalid or missing haptic intent', intent);
        return;
    }
    triggerHapticFeedback(HAPTICS[intent]);
};
